import z from "zod";
import { AccountSchema, OrgSchema, UserSchema } from "../models/generated";

export const AccountDetailSchema = AccountSchema.extend({
  user: UserSchema.nullable(),
  org: OrgSchema.nullable(),
});
export type AccountDetail = z.infer<typeof AccountDetailSchema>;
